<!-- Student Header -->
<ng-container *ngIf="!multipleStudent">
    <student-header [showYearSelector]="true" [pageTitle]="'Schedule History'" class="flex-header" #studentHeader>
    </student-header>
</ng-container>


<ng-container *ngIf="multipleStudent">
    <!-- Page Header -->
    <div class="flex-header">
        <page-header pageTitle='Schedule History'></page-header>
    </div>
</ng-container>

<div class='flex-content'>
    <!-- Search Controls -->
    <ng-container *ngIf="multipleStudent">
        <div style="min-width: 1000px;">
            <form id="entryForm" (keydown)="keyDownFunction($event)">
                <table>
                    <tr>
                        <td>
                            <div>
                                <fieldset>
                                    <legend>Class Entry Date</legend>
                                    <tyl-datepicker style="width:60px"
                                        [(value)]="scheduleHistorySearchModel.classEntryDateFrom" label="From"
                                        [isRequired]="false" (dateInputChange)="classEntryDateFrom = $event">
                                    </tyl-datepicker>
                                    <tyl-datepicker style="width:60px;margin-left: 75px;"
                                        [(value)]="scheduleHistorySearchModel.classEntryDateTo" label="To"
                                        [isRequired]="false" (dateInputChange)="classEntryDateTo = $event">
                                    </tyl-datepicker>
                                </fieldset>
                            </div>
                        </td>
                        <td>
                            <tyl-form-field class="header-input" label="Last Name" style="margin-left: 25px;">
                                <input id="lastNameInputAlt" [(ngModel)]="scheduleHistorySearchModel.lastName"
                                    name="Last Name" matInput aria-label="Last Name" />
                            </tyl-form-field>
                            <tyl-form-field class="header-input" label="First Name" style="margin-left: 15px;">
                                <input aria-label="First Name" [(ngModel)]="scheduleHistorySearchModel.firstName"
                                    matInput name="First Name" id="firstNameInput">
                            </tyl-form-field>
                            <tyl-form-field class="header-input" label="Student #" style="margin-left: 15px;">
                                <input aria-label="Student#" matInput name="Student#" id="student#Input"
                                    [(ngModel)]="scheduleHistorySearchModel.studentNumber">
                            </tyl-form-field>
                            <tyl-button image="csv.png" [showLabel]="false" style="margin-left: 15px;"
                                (clickEvent)="enterStudentNumbers()"></tyl-button>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <fieldset>
                                <legend>Class Exit Date</legend>
                                <div>
                                    <tyl-datepicker id="exitFromDateId" style="width:60px;" label="From"
                                        [(value)]="scheduleHistorySearchModel.classExitDateFrom" [isRequired]="false"
                                        (dateInputChange)="classExitDateFrom = $event">
                                    </tyl-datepicker>
                                    <tyl-datepicker style="width:60px;margin-left: 75px;" label="To"
                                        [(value)]="scheduleHistorySearchModel.classExitDateTo"
                                        [isRequired]="false" (dateInputChange)="classExitDateTo = $event">
                                    </tyl-datepicker>
                                </div>
                            </fieldset>
                        </td>
                        <td>
                            <tyl-form-field label="Student List" style="margin-left: 25px">
                                <mat-select id="studentListInput" [(ngModel)]="scheduleHistorySearchModel.studentListId"
                                    name="studentListInput">
                                    <mat-option *ngFor="let studentList of studentLists" [value]="studentList.ID">
                                        {{studentList.Name}}
                                    </mat-option>
                                </mat-select>
                            </tyl-form-field>
                            <tyl-form-field label="Team" style="margin-left: 15px;">
                                <mat-select name='Team' [(ngModel)]="scheduleHistorySearchModel.studentTeamId">
                                    <mat-option *ngFor='let team of teams' [value]='team.Id'>
                                        {{team.StudentTeamName}}
                                    </mat-option>
                                </mat-select>
                            </tyl-form-field>
                            <tyl-form-field label="Counselor" style="margin-left: 15px">
                                <mat-select name="Counselor" id="counselorSelect"
                                    [(ngModel)]="scheduleHistorySearchModel.counselorId">
                                    <mat-option *ngFor='let c of counselor' [value]='c.ID'>{{c.NAME}}
                                    </mat-option>
                                </mat-select>
                            </tyl-form-field>
                            <button mat-stroked-button class="button" style="margin-left: 25px;width: 120px;"
                                type="button" (click)="clearFilters()">Start Over</button>
                            <input type="submit" form="entryForm" style="display: none" #validationTrigger>
                            <button mat-flat-button color="primary" (click)="validationTrigger.click();searchClick();"
                                class="button" style="width: 120px;background-color: #3f51b5;margin-left: 15px;"
                                type="button">Search</button>
                        </td>
                    </tr>
                </table>
            </form>
        </div>
    </ng-container>
    <div style="min-width: 1200px;overflow:auto;height: 100%;">
        <!-- Mat Table -->
        <mat-table #table [dataSource]="angularMatData" matSort matSortActive="COURSECODE"
        matSortDirection="asc">
            <!-- STUDENTNAME -->
            <ng-container matColumnDef="STUDENTNAME">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Student
                    <filter class="mat-filter" [data]="angularMatData" columnName="STUDENTNAME" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.STUDENTNAME}}
                </mat-cell>
            </ng-container>
            <!-- STUDENTID -->
            <ng-container matColumnDef="STUDENTID">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Student #
                    <filter class="mat-filter" [data]="angularMatData" columnName="STUDENTID" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.STUDENTID}}
                </mat-cell>
            </ng-container>
            <!-- COURSE -->
            <ng-container matColumnDef="COURSE">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Course Name
                    <filter class="mat-filter" [data]="angularMatData" columnName="COURSE" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.COURSE}}
                </mat-cell>
            </ng-container>
            <!-- COURSECODE -->
            <ng-container matColumnDef="COURSECODE">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Course #
                    <filter class="mat-filter" [data]="angularMatData" columnName="COURSECODE" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.COURSECODE}}
                </mat-cell>
            </ng-container>
            <!-- SECTION -->
            <ng-container matColumnDef="SECTION">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Section
                    <filter class="mat-filter" [data]="angularMatData" columnName="SECTION" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.SECTION}}
                </mat-cell>
            </ng-container>
            <!-- PERIOD -->
            <ng-container matColumnDef="PERIOD">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Period
                    <filter class="mat-filter" [data]="angularMatData" columnName="PERIOD" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.PERIOD}}
                </mat-cell>
            </ng-container>
            <!-- TERM -->
            <ng-container matColumnDef="TERM">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Term
                    <filter class="mat-filter" [data]="angularMatData" columnName="TERM" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.TERM}}
                </mat-cell>
            </ng-container>
            <!-- TEACHER -->
            <ng-container matColumnDef="TEACHER">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Teacher
                    <filter class="mat-filter" [data]="angularMatData" columnName="TEACHER" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.TEACHER}}
                </mat-cell>
            </ng-container>
            <!-- SCHOOLENTRY -->
            <ng-container matColumnDef="SCHOOLENTRY">
                <mat-header-cell *matHeaderCellDef mat-sort-header> School Entry
                    <filter class="mat-filter" [data]="angularMatData" columnName="SCHOOLENTRY" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.SCHOOLENTRY}}
                </mat-cell>
            </ng-container>
            <!-- SCHOOLEXIT -->
            <ng-container matColumnDef="SCHOOLEXIT">
                <mat-header-cell *matHeaderCellDef mat-sort-header> School Exit
                    <filter class="mat-filter" [data]="angularMatData" columnName="SCHOOLEXIT" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.SCHOOLEXIT}}
                </mat-cell>
            </ng-container>
            <!-- CLASSENTRY -->
            <ng-container matColumnDef="CLASSENTRY">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Class Entry
                    <filter class="mat-filter" [data]="angularMatData" columnName="CLASSENTRY" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.CLASSENTRY}}
                </mat-cell>
            </ng-container>
            <!-- CLASSEXIT -->
            <ng-container matColumnDef="CLASSEXIT">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Class Exit
                    <filter class="mat-filter" [data]="angularMatData" columnName="CLASSEXIT" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.CLASSEXIT}}
                </mat-cell>
            </ng-container>
            <!-- USERNAME -->
            <ng-container matColumnDef="USERNAME">
                <mat-header-cell *matHeaderCellDef mat-sort-header> User
                    <filter class="mat-filter" [data]="angularMatData" columnName="USERNAME" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.USERNAME}}
                </mat-cell>
            </ng-container>
            <!-- LASTUPDATEDDATE -->
            <ng-container matColumnDef="LASTUPDATEDDATE">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Last Updated
                    <filter class="mat-filter" [data]="angularMatData" columnName="LASTUPDATEDDATE" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let data">
                    {{data.LASTUPDATEDDATE}}
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" style="position:sticky"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" tabindex="0"
                style="padding:0px;border-bottom-width:1px;" matRipple class="element-row"></mat-row>
        </mat-table>
    </div>
</div>

<!-- Footer -->
<div class="flex-footer">
    <div class="flex-footer-right" style="display: flex;align-items: center;">
        <error-prompt [errorList]="errors"></error-prompt>
    </div>
</div>